export default __webpack_public_path__ + "static/media/SFFAfter.637deaef.png";